// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commenting-resolution--is-resolved[data-v-4f1b7457].base-btn.btn-icon-only.btn-icon-septim svg polygon{fill:var(--v-green-approve-status-solid)}.commenting-resolution--is-resolved[data-v-4f1b7457].base-btn.btn-icon-only.btn-icon-septim:disabled{pointer-events:none}.commenting-resolution--is-resolved[data-v-4f1b7457].base-btn.btn-icon-only.btn-icon-septim:disabled *{opacity:1}", ""]);
// Exports
module.exports = exports;
